export const WSCommands = {
  tripMonitor: "trip-monitor.trip",
  message: "message",
  messages: "messages",
  threads: "threads",
  thread: "thread",
  tripMonitorRoute: "trip-monitor.route",
  tripTruck: "trip-monitor.truck",
  trip: "trip",
  truckReserved: "truck.reserved",
};
